import styled from 'styled-components';
import {
  SYS_SPACE_RELATIVE_BP2_XL_3_XL,
  SYS_SPACE_RELATIVE_BP_XL_3_XL,
  SYS_SPACE_RELATIVE_BP_LG_3_XL,
  SYS_SPACE_RELATIVE_BP_MD_3_XL,
  SYS_SPACE_RELATIVE_BP_SM_3_XL,
  SYS_SPACE_RELATIVE_BP_XS_3_XL,
  SYS_SPACE_RELATIVE_BP2_XL_2_XL,
  SYS_SPACE_RELATIVE_BP_XL_2_XL,
  SYS_SPACE_RELATIVE_BP_LG_2_XL,
  SYS_SPACE_RELATIVE_BP_MD_2_XL,
  SYS_SPACE_RELATIVE_BP_SM_2_XL,
  SYS_SPACE_RELATIVE_BP_XS_2_XL,
} from '@oneaudi/unified-web-common';
import {
  SYS_SPACE_RELATIVE_3_XL,
  SYS_SPACE_RELATIVE_2_XL,
  SYS_SPACE_RELATIVE_XL,
  SYS_SPACE_RELATIVE_LG,
  SYS_SPACE_RELATIVE_MD,
  SYS_SPACE_RELATIVE_SM,
  SYS_SPACE_RELATIVE_XS,
  SYS_SPACE_RELATIVE_2_XS,
} from '@oneaudi/unified-web-alpha-common-v2';

import type { LayerTypes } from './globals';
import { ALERT, FOCUS_LARGE, FOCUS_SMALL, FULLSCREEN } from './globals';
import { responsiveStyles } from '../utils/responsiveStyles';
import { breakpoints } from '../utils/breakpoints';

const paddingShader = {
  [ALERT]: {
    xxl: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP2_XL_3_XL : SYS_SPACE_RELATIVE_3_XL} 0`, // XXXL_XXL spacing top + bottom,
    xl: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP_XL_3_XL : SYS_SPACE_RELATIVE_XL} 0`, // XXXL_XL spacing top + bottom,
    l: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP_LG_3_XL : SYS_SPACE_RELATIVE_LG} 0`, // XXXL_L spacing top + bottom,
    m: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP_MD_3_XL : SYS_SPACE_RELATIVE_MD} 0`, // XXXL_M spacing top + bottom,
    s: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP_SM_3_XL : SYS_SPACE_RELATIVE_SM} 0 0 0`, // XXXL_S spacing top,
    xs: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP_XS_3_XL : SYS_SPACE_RELATIVE_XS} 0 0 0`, // XXXL_XS spacing top
  },
  [FOCUS_LARGE]: {
    xs: '0',
  },
  [FOCUS_SMALL]: {
    xxl: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP2_XL_2_XL : SYS_SPACE_RELATIVE_2_XL} 0`, // XXL_XXL spacing top + bottom,
    xl: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP_XL_2_XL : SYS_SPACE_RELATIVE_XL} 0`, // XXL_XXL spacing top + bottom,
    l: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP_LG_2_XL : SYS_SPACE_RELATIVE_LG} 0`, // XXL_XXL spacing top + bottom,
    m: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP_MD_2_XL : SYS_SPACE_RELATIVE_MD} 0`, // XXL_XXL spacing top + bottom,
    s: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP_SM_2_XL : SYS_SPACE_RELATIVE_SM} 0 0 0`, // XXL_XXL spacing top,
    xs: `${process.env.IS_LEGACY ? SYS_SPACE_RELATIVE_BP_XS_2_XL : SYS_SPACE_RELATIVE_2_XS} 0 0 0`, // XXL_XXL spacing top
  },
  [FULLSCREEN]: {
    xs: '0',
  },
};

const justifyContent = {
  m: 'center',
  xs: 'flex-end',
};

interface IOneLayerOuter {
  type: LayerTypes;
  zIndex?: number;
  invisible: boolean;
}

const OneLayerOuter = styled.div<IOneLayerOuter>`
  align-items: center;
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  opacity: ${({ invisible }) => (invisible ? '0' : '1')};

  /* stylelint-disable-next-line order/properties-alphabetical-order */
  ${({ zIndex }): string => (zIndex ? `z-index: ${zIndex};` : '')};

  /* stylelint-disable-next-line order/properties-alphabetical-order */
  ${({ type }): string =>
    paddingShader[type] && responsiveStyles({ padding: paddingShader[type] }, breakpoints)}

  ${(): string => responsiveStyles({ 'justify-content': justifyContent }, breakpoints)}
`;

export default OneLayerOuter;
